import { gql } from "@apollo/client";

export const TOKENS = gql`
  query Tokens($where: TokenWhereInput, $skip: Int, $take: Int) {
    tokens(where: $where, skip: $skip, take: $take) {
      data {
        id
        name
        address
        type
        enabled
        organization {
          id
          name
        }
        balances {
          id
          value
        }
        addresses {
          id
        }
      }
      count
    }
  }
`;

export const TOKEN = gql`
  query Token($where: TokenWhereInput) {
    token(where: $where) {
      id
    }
  }
`;

const token = { TOKENS, TOKEN };

export default token;
